import z from 'zod';

export const RESET_PASSWORD_FORM_SCHEMA = z.object({
  email: z.string().email(),
});

export type ResetPasswordFormInput = z.input<typeof RESET_PASSWORD_FORM_SCHEMA>;
export type ResetPasswordFormOutput = z.output<typeof RESET_PASSWORD_FORM_SCHEMA>;
